export default {
  // Componente visual - sin cadenas de texto estáticas traducibles
}
